<template>
  <div class="flex flex-col flex-1 gap-[16px] p-[16px]">
    <slot></slot>
  </div>
</template>
